import React from "react";
export interface IButtonPopUp {
  
    type?: "button" | "submit" | "reset" | undefined;
    className:string;
    children?: React.ReactNode;
    onClick?:()=> void;
}

export const ButtonPopUp:React.FC<IButtonPopUp> = ({type,className,children,onClick }) => {

  return (
    <div >
   <button  type={type} className={className}  onClick={onClick}>
   {
    
    children
   }
   </button>
    </div>
  );
};

export default ButtonPopUp;